/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { baselineAppStyles} from '@insticator/insticator-ui'



/* ++++++++++ --------------- EXPORT : APP : STYLES --------------- ++++++++++ */
export default theme => ({
	...baselineAppStyles
});
